import { render, staticRenderFns } from "./addReport.vue?vue&type=template&id=2ced8293&scoped=true"
import script from "./addReport.vue?vue&type=script&lang=js"
export * from "./addReport.vue?vue&type=script&lang=js"
import style0 from "./addReport.vue?vue&type=style&index=0&id=2ced8293&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ced8293",
  null
  
)

export default component.exports